module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc2-04-ee72104055c7fd673efd256603d313b3.png";